import { useDispatch, useSelector } from 'react-redux';
import { isEqual } from 'underscore';
import type { DiscountDetails } from '../../../store/NCDAndDiscountedPros.types';
import type { IRootDispatch, RootState } from '../../../store/models';
import { useAsyncEffect } from '../../../hooks';

export default function useCheckForDiscounts(): DiscountDetails | null {
  const dispatch = useDispatch<IRootDispatch>();

  const userId = useSelector<RootState>(state => state.user.userId);
  const routeParams = useSelector<RootState>(state => state.route.params);
  const assignments = useSelector<RootState>(state => state.abTest.assignments, isEqual);

  useAsyncEffect(async () => {
    await dispatch.userState.handleUserUpdate();
    dispatch.ncdAndDiscountedPros.checkProviderDiscountEligibility({});
  }, [
    userId,
    routeParams,
    assignments,
    dispatch.ncdAndDiscountedPros,
    dispatch.userState,
  ]);

  return useSelector<RootState, DiscountDetails>(state => state.ncdAndDiscountedPros);
}
